
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/check_roster",
      function () {
        return require("private-next-pages/manual/check_roster.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/check_roster"])
      });
    }
  